module.exports = __webpack_public_path__ + "static/media/shape2_1.2d3e5125.obj";